// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__mei1L","col":"styles_col__2gnae"};